import React from 'react';
import PropTypes from "prop-types";
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minWidth: 550,
    maxWidth: 500
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ControlledDialog = props => {
    const { handleClose, open, title, content, isFullScreen,enableBackDrop } = props;
    return (
      <div>
        <Dialog
          fullScreen={isFullScreen}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                {title}
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
               </Button>
            </DialogActions>
        </Dialog>
      </div>
    );
}

ControlledDialog.propTypes = {
    title: PropTypes.string,
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    enableBackDrop: PropTypes.bool,
    content: PropTypes.string
};

ControlledDialog.defaultProps = {
    title: "",
    open: false,
    content: "",
    handleClose: fn => fn,
    isFullScreen: false,
    enableBackDrop: false 
};

export default ControlledDialog;